import { content as utilsContent } from '../../../../../../utils';

export const content = {
  tooltips: {
    missingAblaufTemplate: 'Kein Ablauf in CServ gepflegt',
    missingStartDate: 'Bitte wähle einen Veranstaltungsbeginn aus',
    missingExpert: 'Bitte wähle eine:n Trainer:in aus',
    missingResourceSelection: 'Bitte wähle mindestens eine Ressource aus',
    errorInSelection: 'Die Auswahl enthält Tage mit Fehlern',
    processing: utilsContent.tooltips.processing,
    formatNotAllowed: 'Für dieses Format dürfen keine Veranstaltungen angelegt werden',
  },
  buttons: {
    save: 'Speichern',
  },
} as const;
